import { ActionTypes } from "../contants/action-type";

const initialState = {
    categories: [],
    categoryType:[],
    category: {}
}

export const CategoryReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_CATEGORY:
            return {...state, categories: payload};
        case ActionTypes.SELECTED_CATEGORY:
            return {...state, category: payload};
        case ActionTypes.CONFIRM_CREATE_CATEGORY:
            return {...state, category: payload};
        case ActionTypes.CONFIRM_EDIT_CATEGORY:
            return {...state, category: payload};
        case ActionTypes.CONFIRM_DELETE_CATEGORY:
            return { ...state, categories: payload };
        case ActionTypes.SELECTED_CATEGORY_TYPE:
            return { ...state, categoryType: payload };
        default:
            return state;
    }
}